import React from "react";
import { Image, Table } from "semantic-ui-react";
import nationwideImage from "../../assets/images/nationwide-coverage.png";
import CheckIcon from "../../assets/images/check_36x36.png";

export const propertyContent = (
  <div>
    <Image inline size="medium" src={nationwideImage} centered />

    <p className={"text-center"}>Nationwide coverage available!</p>
    <Table className={"coverage-area-inner-table"}>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Image inline src={CheckIcon} />
          </Table.Cell>
          <Table.Cell>Daily updates</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Image inline src={CheckIcon} />
          </Table.Cell>
          <Table.Cell>85% of all U.S. residences</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Image inline src={CheckIcon} />
          </Table.Cell>
          <Table.Cell>90% of all sale and loan transactions</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Image inline src={CheckIcon} />
          </Table.Cell>
          <Table.Cell>100 million parcels</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Image inline src={CheckIcon} />
          </Table.Cell>
          <Table.Cell>Daily updates</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Image inline src={CheckIcon} />
          </Table.Cell>
          <Table.Cell>250 million historical deed transactions</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </div>
);

export default propertyContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/Property.js